import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import tracking from 'dibs-tracking';

// components
import CartItem from './item/CartItem';

function CartItems(props) {
    const { portfolioItems, user, viewer } = props;
    const cartItems = get(portfolioItems, 'edges') || [];
    return (
        <div>
            {cartItems.map((edge, index) => {
                const node = get(edge, 'node');
                if (!node) {
                    return null;
                }
                return (
                    <CartItem
                        key={node.portfolioItemId}
                        user={user}
                        viewer={viewer}
                        portfolioItem={node}
                        onClickProduct={() => {
                            tracking.trackEcommerce({
                                type: 'productClick',
                                actionField: {
                                    list: 'cart',
                                },
                                products: [
                                    {
                                        ...node.item.ecommerceTrackingParams,
                                        position: index,
                                    },
                                ],
                            });
                        }}
                    />
                );
            })}
        </div>
    );
}

CartItems.propTypes = {
    portfolioItems: PropTypes.object,
    user: PropTypes.object.isRequired,
    viewer: PropTypes.object,
};

export default createFragmentContainer(CartItems, {
    viewer: graphql`
        fragment CartItems_viewer on Viewer {
            ...CartItem_viewer
        }
    `,
    user: graphql`
        fragment CartItems_user on User {
            ...CartItem_user
        }
    `,
    portfolioItems: graphql`
        fragment CartItems_portfolioItems on PortfolioItemsConnection {
            edges {
                node {
                    ...CartItem_portfolioItem
                    portfolioItemId
                    item {
                        serviceId
                        ecommerceTrackingParams
                    }
                }
            }
        }
    `,
});
